import { getCdnAssetUrl } from '@/assets';

const preloaded = new Set();

/**
 * Preload images so they're cached before the user needs them.
 * @param {string[]} paths - Paths relative to images/assets/ on CDN
 * @param {{ strategy?: 'link' | 'image' }} options
 *   - 'link': <link rel="preload"> — high priority, for above-the-fold images
 *   - 'image': new Image() — background download, for upcoming screens
 */
export function preloadImages(paths, { strategy = 'image' } = {}) {
  if (typeof document === 'undefined') return;

  paths.forEach((path) => {
    if (preloaded.has(path)) return;
    preloaded.add(path);

    const url = getCdnAssetUrl(path);
    if (strategy === 'link') {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      document.head.appendChild(link);
    } else {
      new Image().src = url;
    }
  });
}
